<template>
  <button
    class="btn btn-outline-light px-3 py-2 pe-4 rounded-3 help-button"
    :class="{
      'disabled': disabled,
      'active': active
    }"
    :disabled="disabled"
    type="button"
    @click="submit($event)"
    @keydown.space="submit($event)"
  >
    <fa-icon :icon="['far', 'lightbulb']" class="me-3 text-primary"></fa-icon>
    <slot>
      <!-- Default -->
      <span class="text-primary">Help</span>
    </slot>
  </button>
</template>

<script>

export default {
props: {
  disabled: {
    type: Boolean
  },
  active: {
    type: Boolean
  },
  buttonText: {
    type: String,
    default: ''
  }
},
emits: ['clicked'],
methods: {
  submit() {
    this.$emit('clicked')
  }
}
}
</script>

<style lang="scss" scoped>
.help-button {
  border-color: $border-300;
}
</style>
